import { render, staticRenderFns } from "./GameOverDialog.vue?vue&type=template&id=665e8e52&scoped=true&"
import script from "./GameOverDialog.vue?vue&type=script&lang=js&"
export * from "./GameOverDialog.vue?vue&type=script&lang=js&"
import style0 from "./GameOverDialog.vue?vue&type=style&index=0&id=665e8e52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e8e52",
  null
  
)

export default component.exports